import React from "react";

const Favorites = () => {
  return (
    <div>
      <h3 className="font-weight-bold w-75" style={{ margin: "0px auto" }}>
        Favorites
      </h3>
      <div></div>
    </div>
  );
};

export default Favorites;
